var kind = require("enyo/kind");

require("app/ui/ToastTooltip.less");

module.exports = kind(/** @lends  app.ui.ToastTooltip.prototype */ {

    /**
     * @private
     */
    name: "app.ui.ToastTooltip",

    /**
     * @private
     */
    classes: "app-ui-toast-tooltip",

    /**
     * @private
     */
    tag: "output",

    /**
     * @type {String}
     * @default dialog
     * @public
     */
    accessibilityRole: "status",

    /**
     * @method
     * @private
     */
    rendered: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            setTimeout(this.bindSafely(function() {
                this.addClass("show");
            }), 1000 / 30);
            setTimeout(this.bindSafely(function() {
                this.addClass("hide");
                this.removeClass("show");
            }), 2000);
            setTimeout(this.bindSafely(function() {
                this.destroy();
            }), 2500);
        };
    })

});
